module.exports = __webpack_public_path__ + "img/Sistema-Mercado.ac052aac.jpg";